import React, { createContext, useEffect, useState } from "react";
import { fetchTenantConfig } from "../api/client";
import type { TenantConfig } from "../api/types";
import { useAuth } from "../auth/useAuth";

interface TenantContextValue {
  config: TenantConfig | null;
  isLoading: boolean;
  error: string | null;
}

export const TenantContext = createContext<TenantContextValue>({
  config: null,
  isLoading: true,
  error: null,
});

export function TenantProvider({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, activeTenant } = useAuth();
  const [config, setConfig] = useState<TenantConfig | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated) return;
    // Aspetta che activeTenant sia definito (i platform_admin partono con "")
    if (!activeTenant) return;

    let cancelled = false;
    setIsLoading(true);
    setConfig(null);
    fetchTenantConfig()
      .then((c) => {
        if (!cancelled) {
          setConfig(c);
          setError(null);
        }
      })
      .catch((e) => {
        if (!cancelled) setError(e.message);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  // activeTenant come dipendenza: ogni cambio di tenant ricarica la config
  }, [isAuthenticated, activeTenant]);

  return (
    <TenantContext.Provider value={{ config, isLoading, error }}>
      {children}
    </TenantContext.Provider>
  );
}
